var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneric13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10487_18470)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FEC3DD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.1675,
    y: 12.5667,
    width: 7.6,
    height: 1.93333,
    rx: 0.966667,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10487_18470)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.93485,
    y: 20.1908,
    width: 14.4667,
    height: 15.3333,
    rx: 7.23333,
    transform: "rotate(-16 2.93485 20.1908)",
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.83425,
    y: 16.2333,
    width: 4.06667,
    height: 1.93333,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9342,
    y: 16.1333,
    width: 3.86667,
    height: 2.66667,
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.90103,
    y: 7.49999,
    width: 6.13333,
    height: 9.66667,
    rx: 3.06667,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00098 10.6H9.53431L9.00098 11.8667V10.6Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9343 10.6H14.401L14.9343 11.8667V10.6Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-1_10487_18470",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5252 18.7333C15.3941 19.771 13.8514 20.5899 11.9676 20.5899C10.0947 20.5899 8.559 19.7804 8.41238 18.7514C5.90368 19.4699 4.06763 21.7806 4.06763 24.5201V29.0535H19.9343V24.5201C19.9343 21.7572 18.0668 19.4305 15.5252 18.7333Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5252 18.7333C15.3941 19.771 13.8514 20.5899 11.9676 20.5899C10.0947 20.5899 8.559 19.7804 8.41238 18.7514C5.90368 19.4699 4.06763 21.7806 4.06763 24.5201V29.0535H19.9343V24.5201C19.9343 21.7572 18.0668 19.4305 15.5252 18.7333Z",
    fill: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5252 18.7333L15.5781 18.5405L15.3557 18.4795L15.3268 18.7083L15.5252 18.7333ZM8.41238 18.7514L8.61038 18.7232L8.578 18.4959L8.35732 18.5591L8.41238 18.7514ZM4.06763 29.0535H3.86763V29.2535H4.06763V29.0535ZM19.9343 29.0535V29.2535H20.1343V29.0535H19.9343ZM15.3268 18.7083C15.273 19.1338 14.9215 19.5532 14.3108 19.8736C13.7064 20.1906 12.8827 20.3899 11.9676 20.3899V20.7899C12.9363 20.7899 13.8258 20.5797 14.4966 20.2278C15.1609 19.8793 15.6463 19.3705 15.7237 18.7584L15.3268 18.7083ZM11.9676 20.3899C11.0579 20.3899 10.2384 20.193 9.63493 19.8791C9.0252 19.562 8.67062 19.146 8.61038 18.7232L8.21438 18.7796C8.30076 19.3858 8.78734 19.8891 9.45035 20.234C10.1197 20.5821 11.0044 20.7899 11.9676 20.7899V20.3899ZM4.26763 24.5201C4.26763 21.8722 6.04225 19.6382 8.46745 18.9436L8.35732 18.5591C5.7651 19.3015 3.86763 21.689 3.86763 24.5201H4.26763ZM4.26763 29.0535V24.5201H3.86763V29.0535H4.26763ZM19.9343 28.8535H4.06763V29.2535H19.9343V28.8535ZM19.7343 24.5201V29.0535H20.1343V24.5201H19.7343ZM15.4723 18.9262C17.9293 19.6002 19.7343 21.8496 19.7343 24.5201H20.1343C20.1343 21.6648 18.2043 19.2608 15.5781 18.5405L15.4723 18.9262Z",
    fill: "#111111",
    mask: "url(#path-11-inside-1_10487_18470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7817 8.57778L14.7857 8.58585L14.7911 8.59306C14.9658 8.82568 15.0768 8.98634 15.1571 9.15617C15.2367 9.32467 15.2881 9.50687 15.3359 9.78367L15.3356 9.78372L15.3374 9.79091C15.4339 10.1768 15.4344 10.677 15.4344 10.9667C15.4344 11.1907 15.3725 13.3114 15.3461 14.2052C15.338 14.4808 15.4604 14.7428 15.6759 14.9139H15.0433L15.0488 12.1298V12.1296V11.8992V11.7188L14.8958 11.8144C14.662 11.9606 14.4685 12.047 14.2531 12.0978C14.0363 12.1489 13.7925 12.1654 13.455 12.1655C12.8922 12.139 12.3917 11.7842 12.0435 11.3129C11.7676 10.9396 11.3643 10.6149 10.8724 10.592L9.17246 10.513C9.07981 10.5087 9.00148 10.5809 8.99816 10.6736L8.96171 11.6931H8.96171L8.96168 11.694L8.87554 14.9527H8.39785C8.3887 14.9527 8.38335 14.9501 8.37976 14.9473C8.37558 14.9441 8.3717 14.9389 8.36949 14.9322C8.36728 14.9254 8.36734 14.9189 8.3688 14.9139C8.37006 14.9095 8.37283 14.9042 8.38021 14.8988C8.56458 14.7637 8.671 14.5467 8.66501 14.3182L8.56782 10.6105C8.60643 9.66558 8.97648 8.79993 9.6733 8.16028L9.6733 8.16029L9.67387 8.15976C9.95619 7.89654 10.2762 7.68943 10.6154 7.53856L10.6584 7.52206C11.5254 7.18952 12.4822 7.17512 13.3588 7.48136C13.9016 7.70626 14.3898 8.08025 14.767 8.54851L14.7817 8.57778Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 22.5,
    height: 22.5,
    rx: 11.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10487_18470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10487_18470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6667,
    height: 21.3333,
    fill: "white",
    transform: "translate(4.6676 1.60001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric13);
export default __webpack_public_path__ + "static/media/Generic 13.9d912d052d96fe716568d40125192181.svg";
export { ForwardRef as ReactComponent };